import React from "react";

import { Fragment, useEffect } from "react";
import { string, bool, func, node } from "prop-types";

const Modal = ({
  modal,
  onClose,
  children,
  modalSize,
  className,
  showClose = true,
  modalColor = "",
}) => {
  useEffect(() => {
    if (modal) {
      document.body.classList.add("active-modal");
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
      document.body.classList.remove("active-modal");
    }
  }, [modal]);
  const onCloseModal = () => {
    onClose();
  };

  return (
    <Fragment>
      {modal && (
        <div className={`modal ${className ? className : ""}`}>
          <div className="modal__overlay" onClick={onCloseModal} />
          <div
            className={`modal__content modal__content--${modalSize} modal__content--${modalColor}`}
          >
            {children}
            {showClose && (
              <div className="modal__button--close" onClick={onCloseModal}>
                <img src="/images/cancel-close.svg" alt="close-modal" />
              </div>
            )}
          </div>
        </div>
      )}
    </Fragment>
  );
};

Modal.propTypes = {
  modalColor: string,
  modalSize: string.isRequired,
  modal: bool.isRequired,
  onClose: func.isRequired,
  children: node.isRequired,
  className: string,
  showClose: bool,
};

export default Modal;
